/**
 * @flow
 * @relayHash 83757a4193577cb2b92cd4cdafbfc012
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ModifyPinterestBoardMutation_esMutationVariables = {|
  input: {
    userId: string;
    boardId?: ?string;
    boardName?: ?string;
    clientMutationId?: ?string;
  };
|};
export type ModifyPinterestBoardMutation_esMutationResponse = {|
  +modifyPinterestBoard: ?{|
    +user: ?{| |};
  |};
|};
*/


/*
mutation ModifyPinterestBoardMutation_esMutation(
  $input: ModifyPinterestBoardInput!
) {
  modifyPinterestBoard(input: $input) {
    user {
      ...AccountSettings_user
      id
    }
  }
}

fragment AccountSettings_user on User {
  serviceId
  facebookUserSocialNetwork: socialNetworks(socialNetworkNames: [FACEBOOK]) {
    __typename
    ...FacebookAccountSettings_userSocialNetwork
    ... on Node {
      id
    }
  }
  pinterestUserSocialNetwork: socialNetworks(socialNetworkNames: [PINTEREST]) {
    __typename
    ...PinterestAccountSettings_userSocialNetwork
    ... on Node {
      id
    }
  }
}

fragment FacebookAccountSettings_userSocialNetwork on UserSocialNetwork {
  ... on FacebookSocialNetwork {
    serviceId
    socialId
    status
  }
}

fragment PinterestAccountSettings_userSocialNetwork on UserSocialNetwork {
  ... on PinterestSocialNetwork {
    ...PinterestConnectBoardModal_userSocialNetwork
    serviceId
    status
    pinterest {
      user {
        serviceId
        id
      }
      boards {
        name
        url
        id
      }
      id
    }
    userPreferences {
      board
    }
  }
}

fragment PinterestConnectBoardModal_userSocialNetwork on PinterestSocialNetwork {
  pinterest {
    boards {
      serviceId
      name
      url
      id
    }
    id
  }
  userPreferences {
    board
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifyPinterestBoardInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModifyPinterestBoardMutation_esMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifyPinterestBoardInput!"
          }
        ],
        "concreteType": "ModifyPinterestBoardPayload",
        "name": "modifyPinterestBoard",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "AccountSettings_user",
                "args": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ModifyPinterestBoardMutation_esMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifyPinterestBoardInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "ModifyPinterestBoardMutation_esMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifyPinterestBoardInput!"
          }
        ],
        "concreteType": "ModifyPinterestBoardPayload",
        "name": "modifyPinterestBoard",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "serviceId",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "facebookUserSocialNetwork",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "socialNetworkNames",
                    "value": [
                      "FACEBOOK"
                    ],
                    "type": "[SocialNetworkNames]"
                  }
                ],
                "concreteType": null,
                "name": "socialNetworks",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "FacebookSocialNetwork",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "socialId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "socialNetworks{\"socialNetworkNames\":[\"FACEBOOK\"]}"
              },
              {
                "kind": "LinkedField",
                "alias": "pinterestUserSocialNetwork",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "socialNetworkNames",
                    "value": [
                      "PINTEREST"
                    ],
                    "type": "[SocialNetworkNames]"
                  }
                ],
                "concreteType": null,
                "name": "socialNetworks",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "PinterestSocialNetwork",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Pinterest",
                        "name": "pinterest",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "PinterestBoard",
                            "name": "boards",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "serviceId",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "url",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "PinterestUser",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "serviceId",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "PinterestSocialNetworkUserPreferencesType",
                        "name": "userPreferences",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "board",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "socialNetworks{\"socialNetworkNames\":[\"PINTEREST\"]}"
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation ModifyPinterestBoardMutation_esMutation(\n  $input: ModifyPinterestBoardInput!\n) {\n  modifyPinterestBoard(input: $input) {\n    user {\n      ...AccountSettings_user\n      id\n    }\n  }\n}\n\nfragment AccountSettings_user on User {\n  serviceId\n  facebookUserSocialNetwork: socialNetworks(socialNetworkNames: [FACEBOOK]) {\n    __typename\n    ...FacebookAccountSettings_userSocialNetwork\n    ... on Node {\n      id\n    }\n  }\n  pinterestUserSocialNetwork: socialNetworks(socialNetworkNames: [PINTEREST]) {\n    __typename\n    ...PinterestAccountSettings_userSocialNetwork\n    ... on Node {\n      id\n    }\n  }\n}\n\nfragment FacebookAccountSettings_userSocialNetwork on UserSocialNetwork {\n  ... on FacebookSocialNetwork {\n    serviceId\n    socialId\n    status\n  }\n}\n\nfragment PinterestAccountSettings_userSocialNetwork on UserSocialNetwork {\n  ... on PinterestSocialNetwork {\n    ...PinterestConnectBoardModal_userSocialNetwork\n    serviceId\n    status\n    pinterest {\n      user {\n        serviceId\n        id\n      }\n      boards {\n        name\n        url\n        id\n      }\n      id\n    }\n    userPreferences {\n      board\n    }\n  }\n}\n\nfragment PinterestConnectBoardModal_userSocialNetwork on PinterestSocialNetwork {\n  pinterest {\n    boards {\n      serviceId\n      name\n      url\n      id\n    }\n    id\n  }\n  userPreferences {\n    board\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/__generated__/ModifyPinterestBoardMutation_esMutation.graphql.js